module.exports = __webpack_public_path__ + "img/azure_nest_small.048be135.png";